

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import type { EntitySummary, EventSummary, NarrativeSummary } from '@/lib/types';

interface NarrativeMapViewProps {
  events: EventSummary[];
  locations: EntitySummary[];
  scenes: NarrativeSummary[];
}

export function NarrativeMapView({ events, locations }: NarrativeMapViewProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 400,
        bgcolor: 'action.hover',
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" color="text.secondary">
        Map View
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Geographic visualization coming soon
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
        {events.length} events • {locations.length} locations
      </Typography>
    </Box>
  );
}
